export default {
    CONNECTED: 'CONNECTED',
    CHANNEL_JOINED: 'CHANNEL_JOINED',
    SOCKET_INFO: 'SOCKET_INFO',
    INCOMING_MESSAGE: 'INCOMING_MESSAGE'
}